import { TabEligibleRacesEnum } from "../../types";

export const tabListHeader = {
  [TabEligibleRacesEnum.COMING_RACES]: "Coming Up",
  [TabEligibleRacesEnum.FUTURE_RACES]: "Future Races"
};
